export default {
  首页: "Heim",
  资产: "Vermögenswerte",
  币币: "Währung",
  快捷买币: "P2P-Handel",
  "支持多种方式购买，购买更简单":
    "Unterstützen Sie mehrere Kaufmöglichkeiten, kaufen Sie einfacher",
  语言设置: "Spracheinstellungen",
  确认恢复: "Wiederherstellung bestätigen",
  "输入邮箱，方便我们联系您":
    "Geben Sie Ihre E-Mail-Adresse ein, damit wir Sie kontaktieren können",
  划转: "Transfer",
  行情: "Zitate",
  "24H成交": "24-Stunden-Transaktion",
  累计收益: "Kumuliertes Einkommen",
  充值时间: "Aufladezeit",
  到期时间: "Ablaufdatum",
  数量: "Menge",
  操作: "Arbeiten",
  资产信息: "Asset-Informationen",
  复制地址: "Adresse kopieren",
  链名称: "Kettenname",
  充值地址: "Adresse aufladen",
  收款地址: "Rechnungsadresse",
  账单: "Rechnung",
  提现金额: "Auszahlungsbetrag",
  接收地址: "Empfangsadresse",
  交易密码: "Transaktions Passwort",
  提现全部: "Alle zurückziehen",
  保存图片: "Bild speichern",
  输入您的交易密码: "Transaktions Passwort",
  确定: "Sicher",
  地址: "Adresse",
  注册时间: "Zeichenzeit",
  取消: "Absagen",
  是否划转: "Ob übertragen",
  登录: "Einloggen",
  我的地址: "Meine Adresse",
  登录密码和交易密码: "Anmeldepasswort und Transaktionspasswort",
  注册: "Registrieren",
  密码: "Passwort",
  设置密码: "Passwort festlegen",
  重复密码: "Passwort wiederholen",
  新密码: "Neues Passwort",
  确认新密码: "Bestätigen Sie das neue Passwort",
  充值: "Aufladen",
  充值货币: "Aufladen",
  合约账户充值: "Terminkonto aufladen",
  账户充值: "Konto aufladen",
  其他: "Sonstiges",
  我的邀请码: "Einladungscode",
  提现: "Abheben",
  客服: "Kunde",
  持有详情: "Details halten",
  请输入内容: "Bitte Inhalt eingeben",
  邀请好友来领取奖励: "Laden Sie Freunde ein, um Belohnungen zu erhalten",
  复制链接: "Kopieren",
  重复设置新的密码: "Wiederholen Sie die Einstellung des neuen Passworts",
  保存: "Speichern",
  我的: "Mine",
  "邮箱/手机号": "E-Mail/Handynummer",
  备注: "Anmerkung",
  地址管理: "Meine Adresse",
  我的团队: "Mannschaften",
  联系我们: "Kontaktiere uns",
  竭诚为您服务: "Mit freundlichen Grüßen zu Ihren Diensten",
  提取收益: "Entzugseinkommen",
  带给我的收益: "Mein Vorteil",
  添加: "Hinzufügen",
  名称: "Name",
  添加地址: "Adresse hinzufügen",
  修改地址: "Adresse ändern",
  可提现: "Kann zurückgezogen werden",
  安全中心: "Sicherheitscenter",
  收益划转: "Einkommensübertragung",
  通知中心: "Benachrichtigung",
  "累计收益:": "Kumuliertes Einkommen:",
  注册用户: "Registrierter Nutzer",
  奖励规则: "Belohnungsregeln",
  帮助反馈: "Hilfe-Feedback",
  邀请好友: "Freunde einladen",
  恢复身份: "Identität wiederherstellen",
  选择语言: "Sprache wählen",
  设置新的密码: "Neues Passwort festlegen",
  暂无活动: "Keine Aktivität",
  "月增长量(+)": "Monatliches Wachstum (+)",
  可提取: "Extrahierbar",
  反馈类型: "Feedback-Art",
  赠送: "Hergeben",
  已经复制: "Kopiert",
  保存成功: "Erfolgreich gespeichert",
  划转成功: "Erfolgreiche Übertragung",
  过期: "Abgelaufen",
  提交成功: "erfolgreich eingereicht",
  "服务器繁忙，稍后在试": "Server ist beschäftigt, versuchen Sie es später",
  全部: "Alle",
  一级: "Level 1",
  二级: "Level 2",
  三级: "Stufe 3",
  级: "Klasse",
  删除成功: "Erfolgreich gelöscht",
  选择地址: "Adresse wählen",
  不再提醒: "Keine Erinnerungen",
  "最小充值金额：": "Mindestaufladung:",
  选择币种: "Währung wählen",
  输入投资金额: "Anlagebetrag",
  输入账户密码: "Passwort",
  投资: "Investieren",
  订单编号: "Auftragsnummer",
  投资周期: "Zyklus",
  投资资金: "Mittel",
  投资时间: "Zeit",
  状态: "Bundesland",
  投资中: "Investieren",
  已到期: "Abgelaufen",
  暂无数据: "Keine Daten",
  转入: "Einsteigen",
  邮箱: "Post",
  请输入邮箱: "Email",
  请输入格式正确的邮箱: "E-Mail-Addresse",
  请输入验证码: "Verifizierungs-Schlüssel",
  获取验证码: "Code erhalten",
  请输入邀请码: "Einladungscode",
  今天: "Heute",
  昨天: "Gestern",
  最近七天: "letzten sieben Tage",
  邀请: "Einladen",
  购买数量: "Kaufmenge",
  产品详情: "Produktdetails",
  币种: "Währung",
  利息币种: "Zinswährung",
  理财类型: "Finanztyp",
  产品费率: "Produktpreis",
  进行中: "wird bearbeitet",
  每天: "Jeden Tag",
  请输入搜索关键词: "Bitte Stichwort suchen",
  通知: "Notiz",
  查看更多: "Mehr",
  理财宝: "HODL & verdienen",
  周期: "Zyklus",
  年利率: "APR",
  更多产品: "Mehr Produkte",
  灵活存取: "Flexible Einzahlungen",
  稳定收益: "Stabile Renditen",
  合约指南: "Hilfezentrum",
  资金划转出: "Überweisung aus",
  矿池收益: "Einnahmen aus Mining-Pools",
  提现手续费: "Abhebegebühr",
  冻结资金: "Gelder einfrieren",
  解冻资金: "Entsperren Sie Gelder",
  闪兑支出: "Flash-Ausgaben",
  闪兑收入: "Flash-Exchange-Einnahmen",
  闪兑手续费: "Flash-Umtauschgebühr",
  合约支出: "Futures-Ausgaben",
  合约收入: "Futures-Einnahmen",
  输入的金额不可大于可用金额:
    "Der eingegebene Betrag darf nicht größer sein als der verfügbare Betrag",
  全部兑换成功: "Erfolgreich",
  返回: "Zurückkehren",
  查看历史: "Siehe Verlauf",
  闪兑历史: "Flash-Geschichte",
  支付: "Zahlen",
  获取: "Erhalten",
  时间: "Zeit",
  手续费: "Gebühr",
  折扣: "Rabatt",
  价格: "Preis",
  逐仓: "Isoliert",
  全仓: "Kreuz",
  市价委托: "Marktauftrag",
  限价委托: "Limit-Order",
  请输入本金: "Menge",
  请输入价格: "Preis",
  "可做空/做多": "Kurz lang",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "Kosten",
  做多: "Lang",
  做空: "Kurz",
  仓位信息: "Positionsinformationen",
  一键平仓: "Alle schließen",
  永续: "",
  浮动盈亏: "P&L",
  平仓: "Nah dran",
  反向开仓: "RV geöffnet",
  一键撤销: "Rückgängig machen mit einem Klick",
  倍杠杆: "x",
  执行价格: "Ausübungspreis",
  委托数量: "Anzahl der Bestellungen",
  保证金: "Rand",
  成交价: "Offen",
  创建时间: "Erstellungsdatum",
  撤销: "Widerrufen",
  合约市场: "Terminmarkt",
  交易方向: "Handelsrichtung",
  委托价格: "Bestellpreis",
  委托金额: "Provisionsbetrag",
  资金费率: "Finanzierungsrate",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Eine wiederkehrende Gebühr, die von Long- und Short-Händlern gezahlt wird und alle 8 Stunden abgerechnet wird.",
  "资金费率为正，多方向空方支付资金费用。":
    "Der Finanzierungssatz ist positiv und die Long-Seite zahlt der Short-Seite die Finanzierungsgebühr.",
  "资金费率为负，空方向多方支付资金费用。":
    "Der Finanzierungssatz ist negativ und die Short-Seite zahlt die Finanzierungsgebühr an die mehreren Parteien.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Sind Sie sicher, dass Sie eine umgekehrte Position eröffnen möchten? Die umgekehrte Eröffnungsposition wird mit der aktuellen entgegengesetzten Position gekauft",
  "仓位止盈/止损": "Position Take-Profit/Stop-Loss",
  合约名称: "Zukünfte",
  开仓价格: "Offen",
  指数价格: "Indexpreis",
  止盈设置: "Take-Profit-Einstellung",
  请输入止盈价: "Bitte geben Sie den Take-Profit-Preis ein",
  "当指数价格触达*时，将会触发委托平仓":
    "Wenn der Indexpreis {0} berührt, wird die Order zum Schließen der Position ausgelöst",
  预计盈亏: "Liquidationsmenge",
  当前仓位: "Aktuelle Position",
  平仓金额: "Liquidationsbetrag",
  仓位模式: "Positionsmodus",
  全仓模式: "Vollständiger Lagermodus",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Alle verfügbaren Mittel auf dem Futures-Konto werden als verfügbare Marge betrachtet. Wenn der Positionsverlust den Kontostand übersteigt, wird die Position liquidiert und alle Margen und Positionen gehen verloren. Bitte beachte, dass",
  逐仓模式: "Isolierter Margin-Modus",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Dadurch wird der Position ein bestimmter Margin-Betrag auf dem Futures-Konto zugewiesen. Wenn der Margenverlust unter das Mindestmargenniveau fällt, wird die Position liquidiert. Im isolierten Positionsmodus können Sie die Marge für diese Position erhöhen und verringern.",
  "是否撤销？": "Wird es widerrufen?",
  "是否一键撤销？": "Ist es mit einem Klick rückgängig zu machen?",
  "是否一键平仓？": "Ob eine Position mit einem Klick geschlossen werden soll?",
  持仓保证金: "Positionsmarge",
  风险率: "Risiko",
  未实现盈亏: "P&L",
  可用保证金: "Freie Marge",
  净值: "Neuer Wert",
  账户余额: "Gleichgewicht",
  合约计算器: "Taschenrechner",
  交易记录: "Transaktionen Aufzeichnung",
  "*倍杠杆": "{num} x",
  "平仓盈亏：": "Schluss-GuV:",
  时间筛选: "Zeitfilter",
  仓位类型: "Positionstyp",
  订单状态: "Bestellstatus",
  订单类型: "Auftragsart",
  平仓价格: "Schlusskurs",
  持仓数量: "Menge",
  "手续费(%)": "Bearbeitungsgebühr (%)",
  平仓时间: "Geschäftsschluss",
  平仓类型: "Schließtyp",
  手动平仓: "Handbuch",
  强制平仓: "Zwangsliquidation",
  近1天: "1 Tag",
  近7天: "7 Tage",
  近30天: "30 Tage",
  近180天: "180 Tage",
  持仓: "Position",
  已取消: "Abgesagt",
  分时: "Time",
  "24H额(USDT)": "24-Stunden-Betrag (USDT)",
  "24H低": "24 Std. niedrig",
  "24H量(BTC)": "24-Stunden-Volumen (BTC)",
  "24H高": "24 Stunden hoch",
  "10秒": "10 sekunden",
  "30秒": "30 sekunden",
  "1分": "1 Punkt",
  "3分": "3 Punkte",
  "5分": "5 Punkte",
  "30分": "30 Punkte",
  "1小时": "1 Stunde",
  "4小时": "4 Stunden",
  "8小时": "8 Stunden",
  "1天": "1 Tag",
  "1周": "1 Woche",
  "1月": "Januar",
  单向持仓: "Einbahnstraße",
  杠杆: "Hebel",
  仓位: "Position",
  计算结果: "Berechnungsergebnisse",
  盈亏: "Gewinn-und Verlust",
  收益率: "Rendite",
  计算结果仅供参考: "Die Berechnungsergebnisse dienen nur als Referenz",
  成交后仓位大小: "Positionsgröße nach Transaktion",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Die Berechnungsergebnisse dienen nur als Referenz, die tatsächlichen Ergebnisse können aufgrund von Preisunterschieden abweichen",
  目标价格: "Ziel",
  开始计算: "Fang an zu rechnen",
  强平价格: "Liquidation",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Überprüfen Sie vor dem Aufladen sorgfältig den Namen der Ladekette. Wenn die Aufladung falsch ist, können die Vermögenswerte nicht abgerufen werden. {0}Der Mindestaufladebetrag beträgt {1}; Liegt der Betrag unter diesem Betrag, kann die Plattform den Erhalt nicht bestätigen. Bitte laden Sie keine anderen Vermögenswerte als {2} an diese Adresse auf, da es sonst nicht möglich ist. Um die Vermögenswerte abzurufen, ziehen Sie bitte die Crowdfunding- oder ICO-Adresse nicht direkt, die Plattform fungiert nicht als Proxy für die Ausgabe von Token.",
  "最小输入*": "Mindestens {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Der Mindestauszahlungsbetrag beträgt {0}, die Auszahlungsgebühr wird von Ihrem Auszahlungsbetrag abgezogen. Bevor Sie Münzen abheben, bestätigen und überprüfen Sie bitte die Empfangsadresse und heben Sie nicht {1}an eine andere Adresse als {2} ab, da die Vermögenswerte sonst nicht wiederhergestellt werden. Lassen Sie die Crowdfunding- oder ICO-Adresse nicht direkt abheben, die Plattform wird dies nicht handhaben die Ausgabe von Token.",
  退出登录: "Ausloggen",
  加仓: "Hinzufügen",
  新增仓位: "Hinzufügen",
  输入加仓金额: "Geben Sie den Betrag ein",
  "当前可用:": "Gegenwärtig verfügbar:",
  资产账单: "Vermögensrechnung",
  保存二维码: "QR-Code speichern",
  温馨提示: "Freundliche Tipps",
  "请注意：您当前使用的网络": "Hinweis: Ihr aktuelles Netzwerk",
  输入提现地址: "Geben Sie die Auszahlungsadresse ein",
  "可用金额：": "Verfügbarer Betrag:",
  输入资产密码: "Asset-Passwort",
  可用手续费: "Verfügbare Bearbeitungsgebühr",
  "折扣%": "Rabatt%",
  实扣手续费: "Tatsächliche Abzugsgebühr",
  实际到账: "Tatsächlicher Kredit",
  未设置资产密码: "Asset-Passwort nicht festgelegt",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Zur Sicherheit Ihres Vermögens legen Sie bitte vor der Auszahlung das Vermögenspasswort fest.",
  热榜: "Heiß",
  涨幅榜: "Aufstieg",
  跌幅榜: "Verlierer",
  成交额榜: "Umsatz",
  关于我们: "Über uns",
  登录密码: "Passwort",
  设置: "Konfiguration",
  资产密码: "Asset-Passwort",
  修改登录密码: "Login-Passwort ändern",
  原密码: "Altes Passwort",
  请输入新密码: "Neues Passwort",
  请输入原密码: "Ursprüngliches Passwort",
  确认密码: "Passwort bestätigen",
  确定修改: "OK zum Ändern",
  修改资产密码: "Asset-Passwort ändern",
  验证码: "Verifizierungs-Schlüssel",
  资产密码使用提示: "Tipps zur Verwendung des Asset-Passworts",
  "资产密码用于转移、提取资产和交易。":
    "Das Asset-Passwort wird verwendet, um Assets zu übertragen, abzuheben und zu handeln.",
  "创建与登录密码不同的资产密码。":
    "Erstellen Sie ein anderes Asset-Passwort als das Anmeldepasswort.",
  "定期更改您的资产密码。": "Ändern Sie Ihr Asset-Passwort regelmäßig.",
  提币历史: "Widerrufsgeschichte",
  "金额/余额": "Betrag/Guthaben",
  "手续费/折扣": "Bearbeitungsgebühr/Rabatt",
  自选: "Optional",
  现货: "Stelle",
  市价: "Marktpreis",
  止损设置: "Stop-Loss-Einstellung",
  合约K线图: "Futures-K-Linien-Diagramm",
  "24H量": "24-Stunden-Lautstärke",
  "24H额": "24H Betrag",
  合作指南: "Kooperationsleitfaden",
  盈亏计算: "GuV",
  当前可用: "Gegenwärtig verfügbar",
  请输入加仓金额: "Bitte geben Sie den Erhöhungsbetrag ein",
  请重新输入加仓金额: "Bitte geben Sie den Erhöhungsbetrag erneut ein",
  平仓数量: "Anzahl geschlossen",
  欢迎登录: "Bitte einloggen",
  "忘记密码?": "Passwort vergessen?",
  "还没有账号？": "Sie haben noch kein Konto?",
  立即注册: "Jetzt registrieren",
  繁體中文: "Traditionelles Chinesisch",
  找回密码: "Passwort abrufen",
  下一步: "Nächster Schritt",
  注册账户: "Account registrieren",
  "请输入邀请码(选填)": "Einladungscode (optional)",
  谢邀豪礼: "Einladung",
  "24小时邀请好友排名": "24 Stunden Rangliste Freunde einladen",
  "*人": "{0}",
  "差*人": "{0}Lücke",
  "已超过10万人，每月轻松赚钱":
    "Hat mehr als 100.000 Menschen und verdient jeden Monat leicht Geld",
  最高: "Höchste",
  邀请链接: "Verknüpfung",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Die Plattform und Sie teilen die von Ihren Freunden auf der Plattform generierten Gebühren (Spotutures, Leverage, Flash Exchange)",
  平台和您一起分享手续费: "Teilen Sie die Gebühr zusammen",
  "*级": "{0}Ebene",
  规则: "Regel",
  我的好友: "Freunde",
  好友详情: "Freundesdetails",
  获得好友佣金方案: "Holen Sie sich das Freundschaftsprovisionsprogramm",
  我的等级: "Mein Level",
  我的邀请数据: "Meine Einladungsdaten",
  当前等级: "Aktuelles Level",
  平台奖励您: "Die Plattform belohnt Sie",
  最高可获取平台奖励: "Maximal verfügbare Prämie",
  邀请规则: "Einladungsregeln",
  "邀请*级有效好友": "Lade gültige Freunde der Stufe {0} ein",
  好友等级: "Freundesstufe",
  人: "Personen",
  奖金派送: "Bonus-Lieferung",
  平台奖励: "Plattformbelohnung",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Das endgültige Auslegungsrecht liegt bei der Plattform. Wenn festgestellt wird, dass die Belohnungen der Plattform nicht normal erhalten werden, werden alle Belohnungen abgezogen, und das Konto wird eingefroren, und die Vermögenswerte werden nicht wiederhergestellt.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Ihr Konto muss ein gültiges Konto sein, und die Plattform bestimmt, dass die gültige Kontobedingung (das Konto wird in einer beliebigen Währung aufgeladen) der Mindestwert von {0} USDT ist.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Die Freunde, die Sie einladen, müssen gültige Untergebene sein. Die Plattform legt fest, dass die gültigen Untergebenen (Kontoaufladung in jeder Währung) einen Mindestwert von {0} USDT haben.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Die Konten des Einladenden und des Eingeladenen können nicht zur selben IP gehören.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Das VIP-Level wird anhand der Anzahl der hochrangigen Freunde bewertet, die Sie einladen.",
  佣金成分: "Provisionskomponente",
  收益统计: "Einkommensstatistik",
  昨日收益: "Gestern",
  月收益: "Monatlich",
  获取收益: "Einkommen",
  "总收益：": "Gesamt:",
  "*级好友": "{0}Level-Freund",
  理财购买: "Finanzieller Kauf",
  期限: "Der Begriff",
  可用金额: "Verfügbarer Betrag",
  预估收益: "Geschätzter Gewinn",
  申购上限: "Abonnementlimit",
  项目剩余: "Projekt bleibt",
  "买入后预计*(SGT)开始计算收益。":
    "Erwarten Sie, dass {0}(SGT) zu verdienen beginnt.",
  计息日: "Zinstermin",
  申购日: "Datum kaufen",
  到账日: "Ankunftsdatum",
  到期自动续投: "Automatische Verlängerung nach Ablauf",
  申购: "Abonnement",
  搜索理财项目: "Suchen Sie nach Finanzprogrammen",
  超高年化随心选: "Freie Wahl",
  "自由选择理财币种，稳定超额收益":
    "Freie Wahl der Vermögensverwaltungswährung zur Stabilisierung von Überrenditen",
  理财总资产: "Kaufbetrag",
  累计收益: "Kumuliertes Einkommen",
  申购数量: "",
  立即购买: "Kaufe jetzt",
  年化收益率: "APR",
  理财订单: "Finanzordnung",
  持有: "Halt",
  申购份额: "Zeichnungsanteil",
  到账日期: "Ankunftsdatum",
  申购成功: "Das Abonnement ist erfolgreich",
  到期: "Die Reife",
  是否选择做多: "Entscheiden Sie sich für mehr",
  "可用余额为0 不能操作":
    "Das verfügbare Guthaben ist 0 und kann nicht bedient werden",
  福利中心: "Wohlfahrt",
  奖励记录: "Aufzeichnung",
  我获取到的奖励: "Belohnungen, die ich bekam",
  总价值: "Gesamtwert",
  新手任务: "Anfängeraufgabe",
  身份认证: "Authentifizierung",
  身份验证: "Authentifizierung",
  去验证: "Verifizieren",
  审核中: "Wird überprüft",
  已验证: "Verifiziert",
  认证失败: "Authentifizierung fehlgeschlagen",
  基础认证: "Basiszertifizierung",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Bitte beachten Sie, dass die Authentifizierungsinformationen nach der Überprüfung nicht mehr geändert werden können. Achten Sie darauf, die richtigen Informationen einzugeben",
  "国家/地区": "Land / Region",
  请选择: "Bitte auswählen",
  证件类型: "Art des Zertifikats",
  证件编码: "Dokumentcode",
  身份证: "Ausweis",
  护照: "Reisepass",
  驾驶证: "Führerschein",
  请输入编码: "Bitte Code eingeben",
  名字: "Name",
  请输入: "Bitte eingeben",
  中间名: "Zweiter Vorname",
  选填: "Optional",
  姓氏: "Nachname",
  中国: "China",
  身份上传: "Identitäts-Upload",
  上传身份证: "ID hochladen",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Die oben genannten Materialien müssen in JPG/JPEG/PNormat hochgeladen werden und sicherstellen, dass die klaren Kanten und Ecken des Fotos vollständig sind und die Helligkeit gleichmäßig ist. Und die Größe überschreitet nicht {0}M.",
  确定提交: "Bestätigen Sie die Übermittlung",
  去认证: "De-authentifizieren",
  挑战任务: "Mission herausfordern",
  注册认证任务: "Registrieren Sie sich für Zertifizierungsaufgaben",
  完成注册认证即可领取:
    "Nachdem Sie die Registrierungsbescheinigung ausgefüllt haben, können Sie diese erhalten",
  领取奖励: "Auszeichnung erhalten",
  新人豪礼: "Newcomer-Geschenk",
  "参与人数：": "Die Teilnehmerzahl:",
  条件: "Bedingung",
  入金量: "Kaution",
  完成: "Fertig",
  任务奖励: "Missionsbelohnungen",
  距任务更新: "Aktualisierung von Aufgabe",
  "条件：": "Bedingung:",
  活动规则: "Regel der Aktivität",
  奖励明细: "Belohnungsdetails",
  已获得: "Erhalten",
  交易奖励: "Transaktionsbelohnung",
  Win奖励: "Belohnungen gewinnen",
  已领取: "Erhalten",
  亏损金额超过: "Die Höhe des Schadens übersteigt",
  单笔开仓金额超过: "Der Betrag einer einzelnen offenen Position übersteigt",
  交易量: "Handel",
  待完成: "Ausstehend",
  入金: "Kaution",
  盈利金额超过: "Gewinnbetrag übersteigt",
  开仓金额: "Menge",
  开仓金: "Freie Stelle",
  盈利: "Profitieren",
  亏损: "Verlust",
  领取: "Erhalten",
  未领取: "Ungekürzt",
  待领取: "Ausstehend",
  再交易: "Wiederhandel",
  即可获得: "Bekommen",
  领取成功: "Erfolgreich erhalten",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Alle Aktivitäten werden nach dem letzten Zeitpunkt der Aktivität gezählt, und thncome wird nach Ablauf ungültig.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Die erzielten Einnahmen werden auf Ihr Prämienkonto verteilt und Sie können es jederzeit nach Ihren Bedürfnissen umtauschen und abheben.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Die Art der erhaltenen Belohnungswährung wird entsprechend der Art der Aufgabe ausgegeben.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Das endgültige Interpretationsrecht liegt bei der Plattform. Wenn festgestellt wird, dass es ungewöhnliche Mittel gibt, um den Aufgabenbonus der Plattform zu arbitrieren, hat die Plattform das Recht, die von Ihnen erhaltenen Daten einzufrieren und zu löschen.",
  成长学院: "Hilfe",
  "区块链 & 加密货币": "Blockchain & Kryptowährung",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Ihr One-Stop-Leitfaden für Kryptowährungen, wir begleiten Sie auf dem Weg zu Kryptowährungen.",
  "全仓合约定单的全部保证金。": "Die volle Marge für eine Cross-Futures-Order.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (nicht realisierter P&L - Bearbeitungsgebühr - Übernachtgebühr) = Neuwert / verwendete Marge * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Der nicht realisierte Gewinn und Verlust wirkt sich direkt auf die „verfügbare Marge“ aus. Wenn die nicht realisierten Gewinne und Verluste steigen, wird die verfügbare Marge steigen, und die nicht realisierten Gewinne und Verluste werden sinken, und die verfügbare Marge wird ebenfalls sinken.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (verwendete Marge) + (nicht realisierter Gewinn und Verlust - Bearbeitungsgebühr - Übernachtgebühr)",
  "注:可继续用于开仓的保证金。":
    "Hinweis: Marge, die weiterhin zum Eröffnen von Positionen verwendet werden kann.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (nicht realisierter Gewinn und Verlust – Bearbeitungsgebühr – Übernachtgebühr)",
  "注:当前的资金结余。": "Hinweis: Aktueller Fondssaldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Bezieht sich auf den gesamten Saldo des Futures-Kontos, einschließlich des nicht verfügbaren Saldos.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Hinweis: Je höher der Risikosatz, desto geringer das Risiko, und je niedriger der Risikosatz, desto höher dieser Wert.",
  该功能尚未开发: "Diese Funktion wurde nicht entwickelt",
  重置密码: "Passwort zurücksetzen",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Bitte geben Sie 8-20 Zeichen ein, die Buchstaben, Ziffern und Sonderzeichen enthalten müssen",
  修改成功: "Erfolgreich geändert",
  输入验证码: "Code",
  输入密码: "Passwort",
  详情说明: "Einzelheiten",
  已售罄: "Ausverkauft",
  剩余期限: "Termin",
  限期: "Termin",
  闪兑货币选择: "Flash-Währungsauswahl",
  地区选择: "Regionsauswahl",
  "搜索国家/地区": "Land suchen",
  "身份信息已提交，将在*小时内审核完成":
    "Identitätsinformationen wurden eingereicht und werden innerhalb von {0} Stunden überprüft",
  "选择国家/地区": "Land auswählen",
  "止盈价格需高于*": "Take-Profit-Preis muss höher als {0} sein",
  "止损价格需低于*": "Der Stop-Loss-Preis muss niedriger als {0} sein",
  "止盈价格需低于*": "Take-Profit-Preis muss niedriger als {0} sein",
  "止损价格需高于*": "Der Stop-Loss-Preis muss höher als {0} sein",
  教程详情: "Tutorial-Details",
  请输入止损价: "Bitte geben Sie einen Stop-Loss-Kurs ein",
  活期: "Flexibel",
  赎回后立即到账: "Abheben",
  赎回: "Rückzahlung",
  赎回理财: "Rückzahlung",
  是否赎回当前的理财订单:
    "Ob der aktuelle Vermögensverwaltungsauftrag eingelöst werden soll",
  维护: "Wartung",
  "系统正在维护中……": "Das System wird gewartet...",
  合约: "Zukünfte",
  闪电兑换: "Flash-Swap",
  流水挖矿: "Cloud-Mining",
  邀请豪礼: "Einladung",
  计算器: "Rechner",
  最新价: "Letzter Preis",
  涨跌幅: "Veränderung",
  关注币种添加自选: "Folgen Sie der Währung",
  一键添加自选: "Hinzufügen",
  全标已读: "Lese alles",
  无消息: "Keine Neuigkeiten",
  "暂时还没有收到任何消息通知哦!": "Keine Nachricht erhalten!",
  没有更多数据: "Nicht mehr",
  闪兑: "Tausch",
  从: "Aus",
  "可用余额：": "Gleichgewicht:",
  至: "Zu",
  预览兑换结果: "Vorschau",
  闪兑规则: "Regeln",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Der Markt-Flash-Austausch kann sich ändern, bitte beziehen Sie sich auf den tatsächlich erhaltenen Betrag.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Der Wechselkurs wird von einem Dritten festgelegt. Aufgrund von Wechselkurskosten und Marktschwankungen kann der von Ihnen umgetauschte Wechselkurs höher sein als der Marktwechselkurs. Bitte bestätigen Sie sorgfältig, bevor Sie fortfahren.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Die Plattform erhebt für jeden Umtausch eine Bearbeitungsgebühr von etwa {fee} %, die für die Umtauschkosten an der Börse verwendet wird.",
  确认汇兑: "Bestätigen",
  您预估得到: "Einschätzung",
  汇兑: "Flash-Swap",
  汇兑比例: "Anteil",
  刷新: "Aktualisierung",
  兑换: "Flash-Swap",
  没有更多了: "Nicht mehr",
  搜索币种: "Suche",
  可用: "Verfügbar",
  我知道了: "Kennt",
  最新价格: "Letzter Preis",
  确认: "Bestätigen",
  最大: "max",
  "风险率(%)": "Risiko(%)",
  持仓: "Position",
  当前委托: "Befehl",
  合作交易历史记录: "Geschichte",
  重置: "Zurücksetzen",
  余额: "Gleichgewicht",
  现货账户: "Finanzierungskonto",
  合约账户: "Zukünfte",
  WIN账户: "Gewinnen",
  赏金账户: "Geschenk",
  总资产折合: "Vermögenswert",
  今日收益: "Die von heute",
  充币: "Kaution",
  提币: "Abheben",
  账户权益: "Kontokapital",
  "数量/类别": "Menge/Art",
  全部币种: "Alle Münzen",
  全部类型: "Alle Arten",
  账单信息: "Münze",
  理财赎回: "Finanzielle Erlösung",
  购买理财: "Finanzkauf",
  收入: "Einkommen",
  支出: "Ausgaben",
  到: "Zu",
  资产划转: "Transfer",
  "最少*": "Min*",
  "可用资产：": "Gleichgewicht",
  确认划转: "Transfer",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Transaktionen können nur durch Überweisung von Vermögenswerten auf das entsprechende Konto durchgeführt werden, und für Überweisungen zwischen Konten wird keine Bearbeitungsgebühr erhoben.",
  币种账户选择: "Kontoauswahl",
  选择账户: "Kontoauswahl",
  划转详情: "Informationen übertragen",
  划转明细: "Informationen übertragen",
  收入账单: "Einkommensinformationen",
  支出账单: "Ausgabeninfo",
  金额: "Menge",
  总收益: "Gesamt",
  佣金: "Vergeben",
  用户名: "Nutzername",
  "已领取：": "Erhalten:",
  "未领取：": "Nicht erhalten:",
  "请选择国家/地区": "Bitte Land/Region auswählen",
  请上传身份信息: "Bitte ID hochladen",
  请选择证件类型: "Bitte wählen Sie den Dokumenttyp aus",
  请填写证件编码: "Bitte geben Sie die ID-Nummer ein",
  请填写名字: "Bitte Namen eintragen",
  请填写姓氏: "Bitte geben Sie den Nachnamen ein",
  单向持仓: "Einseitiges Halten",
  投资金额: "Menge",
  天: "Tag",
  请输入手机号: "Telefon",
  搜索: "Suche",
  搜索历史: "Suchverlauf",
  热门推荐: "Heiß",
  "《Xspace Earn协议》": "《Xspace Earn-Protokoll》",
  我已了解并同意: "Ich verstehe und stimme zu",
  协议: "Protokoll",
  Xspace官方中文交流群: "Xspace Offizielle chinesische Gruppe",
  Xspace官方英文交流群: "Xspace Offizielle englische Gruppe",
  预计维护至: "Erwartet",
  更多功能: "Mehr",
  下载APP: "Download",
  理财: "Finanziell",
  推荐: "Empfehlen",
  Telegram官方中文频道: "Telegram offizieller chinesischer Kanal",
  Telegram官方英文频道: "Telegram offizieller englischer Kanal",
  官方邮箱: "Offizielle E-Mail",
  客服邮箱: "Kundendienst-E-Mail",
  上述信息最终解释权归官方所有:
    "Das endgültige Auslegungsrecht liegt beim Beamten",
  IOS版下载: "Herunterladen für IOS",
  Android版下载: "Für Android herunterladen",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Gebühr = Kaufgebühr + Fondsgebühr + Verkaufsgebühr",
  资金划转: "Transfer",
  止盈: "TP",
  止损: "SL",
  自动平仓: "Automatik",
  委托挂单: "Anvertrauter ausstehender Auftrag",
  买: "Besorgen",
  卖: "Verkaufen",
  "买入/做多": "Kaufen/Long",
  "卖出/做空": "Verkaufen/Short",
  详情: "Einzelheiten",
  浮动涨跌: "Höhen und Tiefen",
  最小: "Mind",
  充币数量: "Aufladebetrag",
  请输入充币数量: "Aufladebetrag",
  支付截图: "Zahlungs-Screenshot",
  提交: "Einreichen",
  上传驾驶证: "Führerschein hochladen",
  上传护照: "Reisepass hochladen",
  加载中: "Wird geladen",
  上传成功: "Erfolg",
  充值历史: "Geschichte",
  合约卖出手续费: "Vertragsgebühr",
  合约买入手续费: "Vertragsgebühr",
  系统加款: "Systemerweiterung",
  系统减款: "Systemreduzierung",
  合约资金费率: "Vertragsfinanzierungsrate",
  佣金分成: "Provisionsanteil",
  U本位合约: "Vertrag",
  资产管理: "Vermögenswerte",
  APP下载: "APP-Download",
  全球领先的数字理财平台:
    "Die weltweit führende digitale Vermögensverwaltungsplattform",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handeln Sie sofort Hunderte von digitalen Assets wie Bitcoin und Ethereum",
  "24H涨跌幅": "24H Wechsel",
  查看更多行情: "Weitere Zitate anzeigen",
  近24小时成交量: "Volumen in den letzten 24 Stunden",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Stellen Sie Hunderte von Währungs- und Kontrakthandelspaaren bereit, um diversifizierte Handelsanforderungen zu erfüllen. Die Plattform hat mehr als 20 Millionen Nutzer in 200 Ländern und Regionen und ist die weltweit führende Digital Asset Service-Plattform.",
  用户国家分布: "Länderverteilung der Benutzer",
  用户数: "Benutzernummer",
  交易对: "Handelspaar",
  服务支持: "Service-Unterstützung",
  "随时随地，多平台终端交易":
    "Terminaltransaktionen mit mehreren Plattformen jederzeit und überall",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Das Multi-Terminal ist perfekt kompatibel und kann die Transaktionsanforderungen verschiedener Szenarien jederzeit erfüllen.",
  随时查看实时行情: "Sehen Sie sich jederzeit Echtzeitkurse an",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Kaufen und verkaufen Sie ganz einfach BTC, ETH, DOGE und andere digitale Assets",
  获取您关注的加密货币价格变化预警:
    "Erhalten Sie Benachrichtigungen über Preisänderungen von Kryptowährungen, die Ihnen wichtig sind",
  "查看比特币现货、期货、期权价格":
    "Sehen Sie sich Bitcoin Spot, Futures, Optionspreise an",
  比较各交易所加密货币价格:
    "Vergleichen Sie die Preise von Kryptowährungen an verschiedenen Börsen",
  开启您的数字货币之旅: "Beginnen Sie Ihre digitale Währungsreise",
  快捷购买数字货币: "Kaufen Sie schnell digitale Währungen",
  "使用多种支付方式交易数字货币，安全快捷":
    "Verwenden Sie eine Vielzahl von Zahlungsmethoden, um digitale Währungen sicher und schnell zu handeln",
  最优的交易费率: "beste Transaktionsrate",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Bevorzugte Transaktionsraten, wettbewerbsfähige VIP-Rechte, genießen Sie den besten Qualitätsservice",
  可信赖的安全保障: "Zuverlässige Sicherheit",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Unsere ausgefeilten Sicherheitsmaßnahmen und SAFU-Fonds schützen Ihre digitalen Assets vor allen Risiken.",
  交易: "Handeln",
  币币市场: "Währungsmarkt",
  "24H成交量": "24-Stunden-Lautstärke",
  交易所: "Austausch",
  "24H最高": "24 Stunden hoch",
  "24H最低": "24 Std. Niedrig",
  永续合约: "Unbefristeter Vertrag",
  日涨跌: "Veränderung",
  交易深度: "Transaktionstiefe",
  "资产(合约)": "Vermögenswerte (Verträge)",
  历史仓位: "Historisch",
  兑换记录: "Datensatz austauschen",
  类型: "Typ",
  充值记录: "Rekord aufladen",
  划转记录: "Datensatz übertragen",
  类别: "Kategorie",
  历史账单: "Historisch",
  在线充值: "Aufladen",
  安全设置: "Sicherheitseinstellungen",
  用于账户登录使用: "Für die Kontoanmeldung",
  用户提现时安全验证使用:
    "Sicherheitsüberprüfung und Verwendung, wenn Benutzer Bargeld abheben",
  验证: "Verifizieren",
  万: "Zehntausend",
  随时随地开启交易: "Handeln. Irgendwo.",
  "*货币交易所的所有功能尽在你的手中。":
    "Alle Funktionen des Währungsumtauschs {0} liegen in Ihren Händen.",
  "下载*货币交易所APP。": "Laden Sie die Währungsumtausch-APP {0} herunter.",
  下载自: "Herunterladen von",
  内测版: "Geschlossene Beta",
  下载: "Download",
  扫码下载: "Zum Herunterladen scannen",
  设置您的资产密码: "Richten Sie Ihr Asset-Passwort ein",
  法币: "Fiat",
  我要买: "Kaufen",
  我要卖: "Verkaufen",
  请输入金额: "Bitte geben Sie den Betrag ein",
  汇率: "Tauschrate",
  获得: "erhalten",
  支付通道: "Zahlungskanal",
  收款通道: "Sammelkanal",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Während des Verkaufsprozesses müssen Sie bestätigen, dass Ihre Zahlungsmethode Ihnen gehört.",
  当前法币暂不支持交易对可尝试前往提现:
    "Die aktuelle gesetzliche Währung unterstützt das Handelspaar nicht, Sie können versuchen, es abzuheben",
  前往提现: "zur Auszahlung gehen",
  该法币暂无通道: "Derzeit gibt es keinen Kanal für diese Fiat-Währung",
  "正在出售中，请耐心等待": "Bitte haben Sie etwas Geduld",
  请选择支付通道: "Bitte wählen Sie einen Zahlungskanal aus",
  请选择方式: "Bitte wählen Sie eine Methode aus",
  法币历史: "Fiat-Geschichte",
  买币: "Kaufe Münzen",
  卖币: "Münzen verkaufen",
  失败: "Scheitern",
  已完成: "Abgeschlossen",
  未付款: "Unbezahlt",
  待审核: "ausstehende Bewertung",
  打款中: "Bezahlen",
  订单详情: "Bestelldetails",
  联系客服: "Wenden Sie sich an den Kundendienst",
  到账金额: "Erhaltener Betrag",
  通道: "Gang",
  收款人: "Zahlungsempfänger",
  收款账户: "Accounts erhaltbar",
  "订单出售失败，请查下方失败原因":
    "Die Bestellung konnte nicht verkauft werden, bitte überprüfen Sie den Grund für den Fehler unten",
  失败原因: "Grund des Scheiterns",
  您还未进行付款: "Sie haben keine Zahlung geleistet",
  您已成功购买: "Sie haben erfolgreich eingekauft",
  已取消订单: "Bestellung storniert",
  "订单正在审核中，请耐心等待":
    "Die Bestellung wird überprüft, bitte haben Sie etwas Geduld",
  您已成功出售: "Sie haben erfolgreich verkauft",
  "订单正在打款中，请耐心等待":
    "Die Bestellung wird bezahlt, bitte haben Sie etwas Geduld",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Der Zahlungsvorgang erfordert, dass Sie zu anderen Plattformen gehen, um Bestellungen zu bezahlen, bitte achten Sie auf die Informationssicherheit.",
  当前法币暂不支持交易对可尝试前往充值:
    "Die aktuelle Fiat-Währung unterstützt keine Handelspaare, Sie können versuchen, sie aufzuladen",
  前往充值: "zum Aufladen gehen",
  购买: "Besorgen",
  订单号: "Bestellnummer",
  单价: "Stückpreis",
  到账数量: "Betrag zum Konto",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Es gibt derzeit unbezahlte Bestellungen, möchten Sie weiterhin einen neuen Zahlungsauftrag erteilen?",
  继续支付: "weiter bezahlen",
  重新下单: "Nachbestellen",
  是否确定出售: "Sind Sie sicher zu verkaufen",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Nachdem der Verkauf bestätigt wurde, wird die Plattform dem Käufer zugewiesen, bitte warten Sie geduldig, bis die Plattform übereinstimmt.",
  出售: "verkaufen",
  收款方式: "Zahlungsmethode",
  订单已生成: "Auftrag generiert wurde",
  取消订单: "Bestellung stornieren",
  请在: "bitte unter",
  内完成付款: "vollständige Zahlung innerhalb",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Verlassen Sie die Plattform, melden Sie sich bei der von Ihnen angegebenen Zahlung an, überweisen Sie auf das unten stehende Konto des Verkäufers und vermerken Sie bei der Zahlung unbedingt:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Wenn zum Zeitpunkt der Zahlung keine Bemerkungen gemacht werden, kann der Verkäufer die Zahlung nicht bestätigen, was zum Verlust von Vermögenswerten führt, die nicht wiederhergestellt werden können.",
  "未在规定的时间内付款，订单都将被取消。":
    "Wenn die Zahlung nicht innerhalb der festgelegten Frist erfolgt, wird die Bestellung storniert.",
  姓名: "Name",
  收款姓名: "Name des Zahlungsempfängers",
  开户支行: "Kontoeröffnungsfiliale",
  银行卡号: "Bankkartennummer",
  "付款后，返回本平台":
    "Kehren Sie nach der Zahlung zu dieser Plattform zurück",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Achten Sie darauf, unten auf die Schaltfläche „Ich habe die Zahlung abgeschlossen, den Verkäufer benachrichtigen“ zu klicken",
  未点击卖家不会放款:
    "Wenn Sie nicht klicken, gibt der Verkäufer das Geld nicht frei",
  交易条款: "Bedingungen der Transaktion",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Beim Kauf der Geldquelle müssen Sie über legale und sichere Geldmittel verfügen, bevor Sie handeln können",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Betrug, Schneeballsysteme, Glücksspiel oder andere illegale Finanztransaktionen sind nicht erlaubt",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Nachdem die Transaktion abgeschlossen ist, besteht das Risiko, dass Gelder eingefroren oder des Betrugs verdächtigt werden, Schneeballsysteme, Glücksspielgelder, wir werden U nicht an den Käufer freigeben und eine Rückerstattung leisten",
  "已付款，通知卖家": "bezahlt, Verkäufer benachrichtigen",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Wenn der Käufer {0} Bestellungen am selben Tag storniert, wird die Kauffunktion am selben Tag storniert. Möchten Sie diese Bestellung wirklich stornieren?",
  添加收款方式: "Zahlungsmethode hinzufügen",
  是否删除此收款方式: "Ob diese Zahlungsmethode gelöscht werden soll",
  删除: "löschen",
  请选择法币: "Bitte wählen Sie Fiat-Währung",
  机构名称: "Institutionsname",
  请选择机构: "Bitte wählen Sie eine Einrichtung aus",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Wenn Sie digitale Währung verkaufen, wird dem Käufer die von Ihnen ausgewählte Zahlungsmethode angezeigt. Bitte bestätigen Sie, dass sie korrekt ausgefüllt ist.",
  请选择银行: "Bitte wählen Sie eine Bank aus",
  请输入姓名: "Bitte geben Sie Ihren Namen ein",
  账号: "Konto",
  请输入账号: "Bitte Konto eingeben",
  收款码: "Empfangscode",
  "银行账号/卡号": "Bankkonto/Kartennummer",
  "请输入银行账号/卡号": "Bitte Bankkonto/Kartennummer eingeben",
  "开户支行（选填）": "Kontoeröffnungsfiliale (optional)",
  请输入开户支行: "Bitte geben Sie die Kontoeröffnungsfiliale ein",
  "加入*官方频道": "Tritt dem {0} Offiziellen Kanal bei",
  关于: "Um",
  条款: "Bedingungen",
  其他: "Sonstiges",
  成功: "Erfolg",
  等待: "Warten",
  作废: "Leere",
  确认付款: "bestätige Zahlung",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Ist die Zahlung erfolgt? Wenn die Zahlung bestätigt wird, bestätigt der Händler innerhalb von {0} Minuten, ob die Zahlung eingegangen ist.",
  最大金额: "Höchstbetrag",
  最小金额: "Mindestbetrag",
  付款: "Zahlung",
  法币充值: "Fiat-Währung aufladen",
  法币提现: "Fiat-Entzug",
  待支付: "Bezahlt werden",
  已支付: "Bezahlt",
  商户名: "Händler",
  当前没有添加支付方式: "Derzeit sind keine Zahlungsmethoden hinzugefügt",
  添加后再出售: "Zum Verkauf hinzufügen",
  新人大礼包: "Newcomer-Geschenk",
  注册即可领取: "Registrieren holen",
  立即领取: "Hol es dir jetzt",
  不再提示: "Nicht erneut erinnern",
  "该奖励需在APP中领取，请下载APP":
    "Die Belohnung muss in der APP gesammelt werden, bitte laden Sie die APP herunter",
  去交易: "Handeln",
  期权交易: "Optionshandel",
  交易额: "Transaktionshöhe",
  可用额度: "Verfügbares Kontingent",
  交易周期: "Handelszyklus",
  看涨: "Aufstieg",
  看跌: "Herbst",
  当前持有: "Aktuelle Bestände",
  胜率: "Gewinnrate",
  "盈利/亏损数": "Profiteinbuße",
  累计实现盈亏: "Kumulierter Gewinn und Verlust",
  秒: "Sekunden",
  分: "Minute",
  小时: "Stunde",
  天: "Tage",
  周: "Woche",
  下单时间: "Bestellzeitpunkt",
  剩余时间: "Übrige Zeit",
  买入价: "Kaufpreis",
  结算价: "Abrechnungspreis",
  实现盈利: "Profitieren",
  结算时间: "Abrechnungszeit",
  期权: "Optionen",
  新手教程: "Anfänger-Tutorial",
  我的订单: "Befehl",
  赔率: "Chancen",
  全部订单: "Alle Bestellungen",
  持有订单: "Auftrag halten",
  历史订单: "Bestellverlauf",
  输入交易额度: "Geben Sie den Betrag ein",
  选择交易周期: "Auswahlzeitraum",
  去注册: "Registrieren",
  冻结: "Einfrieren",
  期权支出: "Optionsauszahlung",
  期权收入: "Optionseinkommen",
  用户提现: "Benutzerentzug",
  "是否购买？": "Willst du kaufen?",
  购买成功: "Erfolgreicher Kauf",
  请签名: "Unterschreiben Sie bitte",
  提交签名: "Unterschrift abgeben",
  清空签名: "klare Signatur",
  签名审核中: "Signaturüberprüfung",
  已提交: "Eingereicht",
  扫一扫下载APP: "APP scannen und herunterladen",
  新手领取大礼包: "Neulinge erhalten Spree",
  注册实名即送彩金: "Registrierung und Echtnamen-Bonus",
  交易总额: "Gesamttransaktion",
  资产不足: "Unzureichendes Vermögen",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Wenn der Wettbewerb erfolgreich ist, senden Sie einen Screenshot des Wettbewerbsergebnisses an den Kundenservice, der den Bonus auf Ihr Konto einräumt und Sie können ihn sofort abheben.",
  Win: "Win",
  在线充值: "Online aufladen",
  比赛: "Wettbewerb",
  未开始: "Nicht angefangen",
  赛程: "Zeitlicher Ablauf",
  赛果: "Ergebnis",
  已结束: "Über",
  让球: "Asian handicap",
  进球数: "Over/Under",
  大: "Over",
  小: "Under",
  胜负平: "Win/Lose",
  和局: "Gezeichnetes Spiel",
  投注: "Wetten",
  下注金额: "Einsatzbetrag",
  下注: "Wetten",
  阵容: "Kampfaufstellung",
  分析: "Analysieren",
  输入下注金额: "Eintreten",
  下注成功: "Erfolgreiche Wette",
  投注记录: "Wettrekord",
  未结算: "Keine Abrechnung",
  已结算: "Erledigt",
  流水: "Menge",
  输赢: "Gewinnen oder verlieren",
  赛时: "Spielzeit",
  下注时间: "Wettzeit",
  足彩竞猜: "Fußball-Quiz",
  查看详情: "Prüfen",
  输: "Verlieren",
  赢: "Gewinnen",
  主: "Heimmannschaft",
  客: "Gastmannschaft",
  主胜: "Heimmannschaft gewinnt",
  客胜: "Auswärtsmannschaft gewinnt",
  平: "Gezeichnet",
  已延期: "Verschoben",
  账号异常: "Kontoausnahme",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "Gesamtziele",
  拍摄照片要求: "Fotoanforderungen",
  标准拍摄: "Standardschuss",
  边框缺失: "Rand fehlt",
  照片模糊: "Foto ist verschwommen",
  闪光强烈: "Starker Blitz",
  上传手持证件照: "Laden Sie Handheld-Dokumente hoch",
  上传证件照: "Ausweisfoto hochladen",
  换一张: "Einen ändern",
  出生日期: "Geburtsdatum",
  请选择出生日期: "Bitte Geburtsdatum auswählen",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Nachdem Sie unten die richtige grafische Bestätigung eingegeben haben, erhalten Sie den E-Mail-Bestätigungscode für die Registrierung",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Sie haben noch {0} Zertifizierungen, danach können Sie die Zertifizierung nicht fortsetzen",
  上半场: "Erste Hälfte",
  下半场: "Zweite Hälfte",
  独赢: "1x2",
  上半场独赢: "Erste Hälfte 1x2",
  下半场独赢: "Zweite Hälfte 1x2",
  上半场让球: "Erste Hälfte Handicap",
  下半场让球: "Zweite Hälfte Handicap",
  上半场大小球: "Erste Hälfte Over/Under",
  下半场大小球: "Zweite Hälfte Over/Under",
  波胆: "Correct Score",
  上半场波胆: "Erste Hälfte Correct Score",
  下半场波胆: "Zweite Hälfte Correct Score",
  单双: "Odd/Even",
  上半场单双: "Erste Hälfte Odd/Even",
  下半场单双: "Zweite Hälfte Odd/Even",
  总进球: "Total Goal",
  上半场总进球: "Erste Hälfte Total Goal",
  下半场总进球: "Zweite Hälfte Total Goal",
  单: "Odd",
  双: "Even",
  中场: "Mittelfeld",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Hinweis: Bitte folgen Sie diesem Beispielbild, um Text auf weißes Papier zu schreiben und das Foto mit dem Ausweis zu machen",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "In letzter Zeit wurde eine große Anzahl von Betrugskonten entdeckt und eine Reihe illegaler Konten wurde bestraft. Bei einer Fehleinschätzung als illegales Konto wenden Sie sich bitte an den Online-Kundendienst.",
  最小下注金额: "Mindesteinsatzbetrag",
  参与活动最小下注金额:
    "Mindestwetteinsatz für die Teilnahme an der Veranstaltung",
  记住密码: "Passwort merken",
  比分: "Punktzahl",
  "您还未登录，请先登录": "Bitte loggen Sie sich ein",
  立即登录: "Einloggen",
  下注限额: "Wettlimit",
  可赢金额: "Kann gewinnen",
  闪兑详情: "Flash-Details",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Aufgrund des Wechselkurses wird es eine Differenz zwischen dem Einsatzbetrag und dem tatsächlichen Einsatzbetrag geben, bitte beachten Sie die Bestellung.",
  开赛时间: "Startzeit",
  足球收入: "Fußballeinnahmen",
  足球支出: "Fußballausgaben",
  活动详情: "Aktivitätsdetails",
  为世界杯喝彩: "Ein Hoch auf die WM",
  我的竞猜: "Mein",
  "竞猜比赛、有机会瓜分*USDT":
    "Raten Sie das Spiel und haben Sie die Chance, {0}USDT zu teilen",
  "瓜分*USDT": "Teilen Sie {0}USDT",
  距离活动结束还有: "Ende der Distanz",
  我的门票: "Mein Ticket",
  竞猜结束时间: "Erraten Sie die Endzeit",
  猜比分: "Erraten Sie die Punktzahl",
  "福利派送中，完成任务即可获取门票":
    "Die Wohlfahrtsverteilung ist im Gange. Schließen Sie die Aufgabe ab, um Tickets zu erhalten",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Erfüllen Sie die folgenden Aufgaben, können Sie die entsprechende Anzahl von Tickets erhalten, um am Wettbewerb teilzunehmen",
  时: "Stunde",
  活动: "Aktivität",
  竞猜记录: "Schätze Rekord",
  结果: "Ergebnis",
  任务: "Aufgabe",
  去邀请: "Einladen",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Die Punktzahl jedes Spiels wird erraten, und ${0} kann in Belohnungen für die Teilnahme am Wettbewerb unterteilt werden.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Für die Teilnahme am Quiz sind Tickets erforderlich, die entsprechend den Aufgaben der Plattform erworben werden können.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "Nachdem die Aufforderung erfolgreich war, senden Sie einen Screenshot des Ergebnisses an den Kundenservice. Der Kundenservice wird den Bonus auf Ihr Geldkonto überweisen, und Sie können ihn sofort abheben.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Jeglicher Betrug ist verboten und Belohnungen werden ungültig, wenn Betrug festgestellt wird.",
  "完成任务后，点击咨询客服获得门票。":
    "Klicken Sie nach Abschluss der Aufgabe auf Kundendienst konsultieren, um das Ticket zu erhalten.",
  继续猜: "Rate weiter",
  总单数: "Insgesamt Einzahl",
  赛事筛选: "Event-Screening",
  球队筛选: "Mannschaftsauswahl",
  总金额: "Pauschalbetrag",
  总流水: "Gesamtumsatz",
  派奖金额: "Bonusbetrag",
  下注单数: "Ungerade Zahl setzen",
  利润: "Profitieren",
  更多福利: "Wohlfahrt",
  我的奖金: "Meine Prämie",
  未认证: "Nicht zertifiziert",
  总量: "Gesamt",
  或: "Oder",
  模拟交易: "Demo-Handel",
  体验账户不可操作: "Experience-Konto funktioniert nicht",
  世界杯比分竞猜: "WM-Ergebnis-Quiz",
  "领*USDT起": "Von {0}USDT",
  消息: "Information",
  滚球: "Rollende Kugel",
  是: "ja",
  不是: "nein",
  当前余额: "aktuelles Guthaben",
  KOL招募: "KOL-Rekrutierung",
  本月净输赢: "Nettogewinn/-verlust für den Monat",
  本月佣金: "Kommission des Monats",
  佣金比例: "Provisionssatz",
  活跃人数: "aktive Nummer",
  新增下级: "Untergebenen hinzufügen",
  登录人数: "Anzahl der Anmeldungen",
  首存人数: "Anzahl der Ersteinleger",
  数据分析: "Datenanalyse",
  人数: "Anzahl der Personen",
  新注册存款金额: "Neuer registrierter Einzahlungsbetrag",
  老用户存款金额: "Alter Einzahlungsbetrag des Benutzers",
  首存金额: "Erster Einzahlungsbetrag",
  快捷入口: "Schneller Einstieg",
  成员管理: "Mitgliederverwaltung",
  财务报表: "Jahresabschluss",
  分红报表: "Dividendenbericht",
  订单记录: "Bestellprotokoll",
  VIP专享: "VIP-exklusiv",
  推广工具: "Promotion-Tool",
  计算规则: "Berechnungsregeln",
  账变明细: "Kontoänderungsdetails",
  成员: "Mitglied",
  下级概览: "Untergeordnete Übersicht",
  下级成员总计: "Untergeordnete Mitglieder insgesamt",
  本月新增: "neu in diesem Monat",
  本月活跃会员: "Aktives Mitglied des Monats",
  今日活跃会员: "Aktive Mitglieder heute",
  本月有效活跃: "diesen Monat aktiv",
  活跃成员占比: "Anteil der aktiven Mitglieder",
  本月活跃: "diesen Monat aktiv",
  今日活跃: "heute aktiv",
  下级成员: "jüngeres Mitglied",
  会员账号: "Mitgliedskonto",
  统计时间: "Statistik Zeit",
  筛选: "Filter",
  存款: "Anzahlung",
  取款: "Geld abheben",
  总输赢: "Gesamtgewinn oder -verlust",
  是否有效用户: "Ist es ein gültiger Benutzer",
  最近登录时间: "letzter Anmeldezeitpunkt",
  否: "nein",
  开始时间: "Anfangszeit",
  结束时间: "Endzeit",
  提取: "Extrakt",
  总盈亏: "Gesamtgewinn und -verlust",
  净盈亏: "Nettogewinn und -verlust",
  分红: "Dividenden",
  概览: "Überblick",
  月度详细数据: "Detaillierte Monatsdaten",
  未发放: "nicht ausgegeben",
  活跃用户: "aktiver Nutzer",
  有效新增会员: "Fügen Sie effektiv neue Mitglieder hinzu",
  冲正后净输赢: "Nettogewinn oder -verlust nach dem Flush",
  上月结余: "Saldo des letzten Monats",
  净输赢: "Nettogewinn/-verlust",
  "系统每日新加坡时间1:00更新一次报表":
    "Das System aktualisiert den Bericht jeden Tag um 1:00 Singapur Zeit",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Positive Zahlen in den Daten, Gesamtgewinne und -verluste sowie Nettogewinne und -verluste im Bericht geben den Gewinn des Agenten an, negative Zahlen den Verlust des Agenten",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Die Provisionsdaten werden täglich aktualisiert und dienen nur als Referenz, nicht als tatsächlicher Provisionsverteilungsstandard",
  选择时间: "Auswahlzeitraum",
  足球: "Fußball",
  投注金额: "Einsatzbetrag",
  有效订单: "gültige Bestellung",
  下级账户: "Untergeordnetes Konto",
  待成交: "schwebender Deal",
  下单金额: "Bestellbetrag",
  订单内容: "Inhalt bestellen",
  秒数: "Sekunden",
  联赛: "die Liga",
  队伍: "Team",
  比赛时间: "Wettkampfzeit",
  玩法: "Spielanleitung",
  等级规则表: "Gradierregeltabelle",
  等级: "Klasse",
  活跃会员: "aktives Mitglied",
  最新活跃: "zuletzt aktiv",
  额外佣金: "zusätzliche Provision",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Der Wachstumsstandard und das Belohnungssystem des entsprechenden Levels werden jeden Monat implementiert, und es kann nur eine Level-Belohnung genossen werden.",
  渠道生成: "Kanalgenerierung",
  创建: "schaffen",
  渠道名称: "Kanal Name",
  注册人数: "Anzahl der Anmeldungen",
  浏览人数: "Zuschauer",
  构建状态: "Bauzustand",
  禁用: "deaktiviert",
  启用: "aktivieren",
  查看: "Prüfen",
  创建渠道: "Kanal erstellen",
  创建成功: "erfolgreich erstellt",
  操作成功: "Erfolgreiche Operation",
  渠道详情: "Kanaldetails",
  邀请码: "Einladungscode",
  访问人数: "Besucherzahl",
  渠道地址: "Kanaladresse",
  我的福利: "meine vorteile",
  充值福利: "Vorteile aufladen",
  当前流水: "aktueller Durchfluss",
  如何参与: "wie man teilnimmt",
  币种充值: "Währungsaufladung",
  充值福利中领取福利: "Profitieren Sie von Aufladevorteilen",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regeln: Der Erhalt des Aufladevorteils ist freiwillig und die Gültigkeitsdauer beträgt 24 Stunden nach dem Aufladen. Nach dem Ablaufdatum wird er ungültig. Nach Erhalt wird die Bargeldabhebungsfunktion vorübergehend gesperrt, und die Bargeldabhebung kann sein nach Erreichen des Umsatzes freigeschaltet.",
  失效日期: "Haltbarkeitsdatum",
  "暂无福利领取，充值后领取":
    "Noch keine Vorteile zu erhalten, erhalten Sie nach dem Aufladen",
  参与: "sich beteiligen",
  充值赠送: "Geschenk aufladen",
  "领取*%的赠送": "Erhalte {0}% Geschenk",
  去领取: "sammeln",
  VIP奖励: "VIP-Belohnungen",
  "当前可领取*USDT，是否确认领取":
    "Kann derzeit {0}USDT empfangen, bestätigen Sie die Behauptung?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Nach der Beanspruchung wird die Auszahlungsfunktion vorübergehend gesperrt, und die Sperre kann entsperrt werden, wenn Ihr Umsatz {0}USDT erreicht",
  充值送大礼: "Aufladen, um ein großes Geschenk zu erhalten",
  "存入越多，送越多！": "Je mehr Sie einzahlen, desto mehr bekommen Sie!",
  无效: "ungültig",
  有效: "effizient",
  总存金额: "Gesamtbetrag der Einzahlung",
  提示: "Hinweis",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positive Zahlen bei Gesamtgewinnen und -verlusten sowie Nettogewinnen und -verlusten stellen Plattformgewinne dar, und negative Zahlen stellen Verluste dar. Die täglichen Daten dienen nur als Referenz und dienen nicht als tatsächlicher Provisionsverteilungsstandard.",
  "净盈亏：总盈亏-用户返水":
    "Nettogewinn und -verlust: Gesamtgewinn und -verlust - Benutzerrabatt",
  盈利方: "Profitable Partei",
  代理: "Schauspielkunst",
  客户: "Klient",
  平局: "zeichnen",
  平台: "Plattform",
  "已提交审核，请耐心等待":
    "Zur Überprüfung eingereicht, bitte haben Sie etwas Geduld",
  充值日期: "Aufladedatum",
  平台本月总输赢: "Gesamtgewinne und -verluste der Plattform in diesem Monat",
  KOL招募合作: "KOL Rekrutierungskooperation",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Die Plattform ist jetzt geöffnet [KOL Recruitment Event], solange Sie ein Social-Media-Konto haben, können Sie mit der Plattform einen einmaligen Bonus genießen, um Kunden zu werben, und Sie können lebenslange Vorteile genießen.",
  级别: "Niveau",
  平台利润返佣: "Plattform-Gewinnrückerstattung",
  佣金案例: "Kommissionsfall",
  交易项目: "Transaktionsartikel",
  "期权交易、合约交易、足球游戏":
    "Optionshandel, Kontrakthandel, Fußballspiele",
  报名方式: "Möglichkeiten der Anmeldung",
  点击KOL招募报名: "Klicken Sie auf KOL-Rekrutierungsregistrierung",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Willkommen in unserem Team, die Plattform unterstützt Sie voll und ganz beim Aufbau Ihres eigenen Benutzersystems, und Sie können die höchste{0} Provision erhalten, wir freuen uns auf Ihren Beitritt.",
  输入联系方式: "Kontaktdaten eingeben",
  最低活跃人数: "Aktive Mindestanzahl",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Zum Beispiel: die Anzahl der aktiven Benutzer in diesem Monat ≥ {0} und der Gesamtgewinn oder -verlust der Plattform in diesem Monat ≥ {1}USDT, wenn Sie dem Level {2} angehören, können Sie {3}% Provision erhalten.",
  比分竞猜: "Punktequiz",
  豪礼相赠: "Geschenk",
  足球活动: "Fußball Aktivität",
  圣诞节活动: "Weihnachtsaktivitäten",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Sie haben an der Aktivität teilgenommen und die Auszahlungsfunktion vorübergehend gesperrt. Sie benötigen {0} USDT flow, um sie zu entsperren.",
  剩余流水: "Restwasser",
  助力足球: "Fußball fördern",
  佣金累计: "Gesamtprovision",
  有效投注: "Gültige Wette",
  今日: "Heute",
  今日返水: "Rabatt heute",
  VIP返水: "VIP-Rabatt",
  返水记录: "Rabatt-Datensatz",
  成员信息: "Mitgliederinformation",
  基本信息: "Grundinformation",
  钱包余额: "Wallet-Guthaben",
  投注信息: "Wettinformationen",
  返水: "Abzug",
  总下注: "Gesamtwette",
  今日输赢: "Heute gewinnen oder verlieren",
  下注动态: "Wettdynamik",
  返水奖励: "Rabattbonus",
  分红金额: "Dividendenbetrag",
  返水支出: "Rabattauszahlung",
  总返水: "Gesamtrabatt",
  流水总额: "Gesamtumsatz",
  返水总额: "Gesamtrabatt",
  返水详情: "Rabattdetails",
  日流水: "Täglich Wasser",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Die Plattform bietet zusätzliche Rabattprämien basierend auf dem täglichen Umsatz Ihres Mitarbeiters, und die Prämien werden täglich um 00:00 Uhr Singapur-Zeit auf das Prämienkonto verteilt",
  "申请成功，等待审核":
    "Die Bewerbung ist erfolgreich und wartet auf die Überprüfung",
  "我出本金，盈利共分享": "Ich zahle den Hauptbetrag und teile den Gewinn",
  最高分红: "höchste Dividende",
  投资大师比赛: "Investment-Master-Wettbewerb",
  "我出本金，你盈利": "Ich zahle die Hauptsumme, Sie profitieren",
  共分享: "geteilt",
  最高分红可得: "Maximal verfügbare Dividenden",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Es kommen exklusive Vorteile für neue Benutzer, kostenlose ${0}, Sie können in jedes Projekt auf der Plattform investieren, nachdem Sie es erhalten haben, und Sie können es sofort abheben, nachdem Sie einen Gewinn erzielt haben.",
  报名领取: "Melden Sie sich an, um zu erhalten",
  已领取: "empfangen",
  审核驳回: "Bewertung abgelehnt",
  驳回原因: "Grund für die Ablehnung",
  活动运行周期: "Aktivitätslaufzyklus",
  "申请成功后起至*天内完成超额收益。":
    "Nach erfolgreicher Beantragung werden die überschüssigen Einnahmen innerhalb von {0} Tagen abgerechnet.",
  分红比: "Dividendenverhältnis",
  "*日获得盈利后，可获得*%的收益额。":
    "Nachdem Sie am {0} Tag Gewinn erzielt haben, können Sie {1}% des Gewinns erhalten.",
  参与条件: "Teilnahmebedingungen",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Benutzer in Russland und der Türkei nahmen nicht teil.",
  计算项目: "Berechnungselement",
  "合约、体育、期权": "Verträge, Sport, Optionen",
  我的投资: "meine Investition",
  参与天数: "Teilnahme Tage",
  累计下注: "kumulative Wette",
  累计盈亏: "Kumulierter Gewinn und Verlust",
  预计可分红: "Voraussichtlich Dividenden zahlen",
  常见问题: "häufiges Problem",
  什么是平台出资: "Was ist Plattformfinanzierung?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Laut Benutzern in einigen Ländern stellt die Plattform den Benutzern kostenlose Mittel zur Verfügung, um in Projekte zu investieren.",
  怎么获取平台出资的福利: "So erhalten Sie die Vorteile des Plattformbeitrags",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Sie müssen nur ein Benutzer in einem bestimmten Land sein, klicken Sie oben auf die Registrierungsschaltfläche, und {0}USDT wird auf das Prämienkonto unter dem Girokonto übertragen, nachdem die Plattformüberprüfung abgeschlossen ist, und Sie können es auf andere Konten für Investitionen übertragen.",
  什么是分红: "was ist eine dividende",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividende bedeutet, dass innerhalb eines bestimmten Zeitraums, nachdem die Erträge 100 % erreicht haben, 50 % der überschüssigen Erträge ausgeschüttet werden können. Beispiel: Um 100 USDT Geld zu erhalten, beträgt der Einkommensbetrag 120 %.",
  "如何取得分红？": "Wie bekomme ich Dividenden?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Der Aktivitätszyklus ist einmal jeden Tag. Nachdem die Aktivität beendet ist, wird sie berechnet und die Dividenden werden nach Erfüllung der Aktivitätsanforderungen auf das Prämienkonto ausgeschüttet. Wenn Sie die Aktivitätsanforderungen nicht erfüllen, werden Ihre Einnahmen und Plattformbeiträge automatisch vom System gelöscht.",
  活动规则: "Aktivitätsregeln",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Teilnehmende Konten müssen sich einer KYC-Verifizierung unterziehen, und jedes Konto ist auf einen Vorteil beschränkt.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "Das KYC der teilnehmenden Konten erfordert das angegebene Land zur Teilnahme, und andere Regionen sind nicht zur Teilnahme berechtigt. Bitte überprüfen Sie, ob das aktive Land mit Ihrem Land übereinstimmt.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Nach erfolgreicher Teilnahme an der Aktivität wird das Konto Ihre Auszahlungsfunktion vorübergehend sperren und Ihre Auszahlungsfunktion wird nach Abschluss der Aktivität freigegeben.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Bitte halten Sie sich an die Aktivitätsregeln der Plattform. Wenn Sie Betrug finden oder Systemschlupflöcher gewinnbringend ausnutzen, wird die Plattform alle Gelder auf Ihrem Konto für lange Zeit einfrieren.",
  平台出资: "Plattforminvestition",
  平台出资收回: "Wiederherstellung von Plattforminvestitionen",
  投资大师奖励: "Investment Master Award",
  请下载APP添加收款方式:
    "Bitte laden Sie die APP herunter, um eine Zahlungsmethode hinzuzufügen",
  请下载APP进行身份验证:
    "Bitte laden Sie die APP zur Identitätsprüfung herunter",
  请下载APP参与: "Bitte laden Sie die APP herunter, um teilzunehmen",
  技术指标: "Technische Indikatoren",
  主图: "Hauptbild",
  副图: "Unterbild",
  新注册人数: "Neue Registranten",
  老用户存款人数: "Alte Benutzereinlagen",
  存款人数: "Anzahl der Einleger",
  取款人数: "Anzahl der Auszahlungen",
  投注人数: "Anzahl der Wetter",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Außer Indonesien, Indien, Bangladesch und Benutzer, die nicht teilgenommen haben.",
  市场动态: "Marktdynamik",
  外汇合约: "Devisenvertrag",
  盈亏比: "Gewinn-Verlust-Verhältnis",
  委托价: "Bestellpreis",
  可用余额: "Verfügbares Guthaben",
  持仓额: "Positionsbetrag",
  强平价: "Starke Parität",
  修改: "Überarbeiten",
  修改价位: "Preis ändern",
  外汇: "Forex",
  外汇账户: "Forex-Konto",
  我的交易: "meine Transaktion",
  未设置: "nicht eingestellt",
  超出最大可设数值: "Überschreitet den maximal einstellbaren Wert",
  超出最小可设数值: "Überschreitet den minimal einstellbaren Wert",
  止盈超出最小可设数值:
    "Der Take-Profit übersteigt den einstellbaren Mindestwert",
  止损超出最大可设数值:
    "Stop-Loss überschreitet den maximal einstellbaren Wert",
  止盈超出最大可设数值:
    "Der Take-Profit übersteigt den maximal einstellbaren Wert",
  止损超出最小可设数值:
    "Stop-Loss überschreitet den minimal einstellbaren Wert",
  挖矿: "Bergbau",
  交易账户: "Transaktionskonto",
  买涨: "Aufkaufen",
  买跌: "Kaufen oder verkaufen",
  请输入正确的银行卡信息:
    "Bitte geben Sie die korrekten Bankkarteninformationen ein",
  联系在线客服: "Kontaktieren Sie den Online-Kundendienst",
  法币交易请联系在线客服:
    "Für legale Währungstransaktionen wenden Sie sich bitte an den Online-Kundendienst",
  提交订单: "Bestellung abschicken",
  "支付过程如有疑问,请联系在线客服":
    "Bei Fragen zum Bezahlvorgang wenden Sie sich bitte an den Online-Kundenservice",
  彩金赠送: "Lotteriegeschenk",
  在线客服: "Onlineservice",
  最少投资: "Mindestinvestition",
  "提交时间:": "Abgabetermin:",
  提现拒绝: "Widerruf abgelehnt",
  认证拒绝: "Authentifizierung abgelehnt",
  认证通过: "Zertifizierung bestanden",
  请输入正确的交易额度: "Bitte geben Sie den korrekten Transaktionsbetrag ein",
  最大下注金额: "Maximaler Einsatzbetrag",
  手机号: "Telefonnummer",
  邮箱注册: "E-Mail Registrierung",
  手机号注册: "Registrierung der Mobiltelefonnummer",
  查询: "Anfragen",
  手机号登录: "Anmeldung über die Mobiltelefonnummer",
  邮箱登录: "E-Mail-Login",
  请输入数量: "Bitte Menge eingeben",
  可用数量: "Verfügbare Menge",
  钱包登录: "Wallet-Login",
  请输入正确的邀请码: "Bitte geben Sie den richtigen Einladungscode ein",
  "请输入邀请码(必填)": "Bitte geben Sie den Einladungscode ein (erforderlich)",
  输入正确的金额: "Geben Sie den korrekten Betrag ein",
  法币充值: "mit Landeswährung aufladen",
  卢比充值: "Rupien Aufladen",
  请输入法币: "Bitte geben Sie die Landeswährung ein",
  请输入IFSC: "Bitte geben Sie IFSC ein",
  "银行编码(选填)": "Bankleitzahl (optional)",
  请输入银行编码: "Bitte geben Sie die Bankleitzahl ein",
  请输入大于8位数的密码:
    "Bitte geben Sie ein Passwort mit mehr als 8 Ziffern ein",
  添加成功: "Erfolgreich hinzugefügt",
  "60秒": "60 Sekunden",
  "180秒": "180 Sekunden",
  "300秒": "300 Sekunden",
  "2次密码不一致": "2 Passwörter sind inkonsistent",
  输入提币数量: "Geben Sie den Auszahlungsbetrag ein",
  图片格式不正确: "Das Bildformat ist nicht korrekt",
  图片大于20M: "Das Bild ist größer als 20 MB",
  请设置委托价格: "Bitte setzen Sie den Auftragspreis fest",
  输入资金密码: "Geben Sie das Kapitalpasswort ein",
  验证码错误: "Fehler im Bestätigungscode",
  充值拒绝: "Aufladen abgelehnt",
  请输入SSN: "Bitte geben Sie die SSN ein",
  合约交易: "Vertragshandel",
  结算完成: "Abrechnung abgeschlossen",
  继续下单: "Weiter bestellen",
  最低购买: "Mindesteinkauf",
  最高购买: "höchster Kauf",
  限价: "Limitpreis",
  买入价格: "Kaufpreis",
  买入量: "Kaufmenge",
  卖出价格: "Verkaufspreis",
  卖出量: "Verkaufsmenge",
  买入: "Kaufen",
  卖出: "Verkaufen",
  订单创建成功: "Bestellung erfolgreich erstellt",
  币币买入支出: "Ausgaben für Währungskauf",
  币币买入支出退还: "Rückerstattung der Währungskauf-Ausgaben",
  币币买入获得: "Erhaltene Währung durch Kauf",
  币币卖出支出: "Ausgaben für Währungsverkauf",
  币币卖出支出退还: "Rückerstattung der Währungsverkauf-Ausgaben",
  币币卖出获得: "Erhalt durch Währungsverkauf",
  币币交易手续费: "Transaktionsgebühr für Währungshandel",
  请输入限价: "Bitte Limitpreis eingeben",
  成交: "Abgeschlossen",
  等待成交: "Warten auf Abschluss",
  交易完成: "Transaktion abgeschlossen",
  被取消: "Abgebrochen",
  交易时间: "Transaktionszeit",
  法币交易: "Fiat-Währungs-Handel",
  法币出售: "Fiat-Währung Verkauf",
  两次密码不一致: "Die beiden Passwörter stimmen nicht überein",
  再次输入账户密码: "Bitte das Passwort erneut eingeben",

  美国: "Vereinigte Staaten",
  韩国: "Südkorea",
  阿尔巴尼亚: "Albanien",
  津巴布韦: "Simbabwe",
  赞比亚: "Sambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikanische Jungferninseln",
  英属处女群岛: "Britische Jungferninseln",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Usbekistan",
  乌拉圭: "Uruguay",
  英国: "Vereinigtes Königreich",
  阿拉伯联合酋长国: "Vereinigte Arabische Emirate",
  乌克兰: "Ukraine",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- und Caicosinseln",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Türkei",
  突尼斯: "Tunesien",
  特立尼达和多巴哥: "Trinidad und Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Osttimor",
  泰国: "Thailand",
  坦桑尼亚: "Tansania",
  塔吉克斯坦: "Tadschikistan",
  中国台湾: "Taiwan (China)",
  叙利亚: "Syrien",
  瑞士: "Schweiz",
  瑞典: "Schweden",
  斯威士兰: "Swasiland",
  苏里南: "Suriname",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spanien",
  南非: "Südafrika",
  索马里: "Somalia",
  所罗门群岛: "Salomonen",
  斯洛文尼亚: "Slowenien",
  斯洛伐克: "Slowakei",
  "圣马丁岛（荷兰部分）": "Sint Maarten (niederländischer Teil)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellen",
  塞尔维亚: "Serbien",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudi-Arabien",
  圣多美和普林西比: "São Tomé und Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "St. Kitts und Nevis",
  圣文森特和格林纳丁斯: "St. Vincent und die Grenadinen",
  圣彼埃尔和密克隆岛: "Saint-Pierre und Miquelon",
  圣露西亚: "St. Lucia",
  圣基茨和尼维斯: "St. Kitts und Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Russland",
  罗马尼亚: "Rumänien",
  留尼汪: "Réunion",
  刚果共和国: "Kongo Republik",
  卡塔尔: "Katar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polen",
  菲律宾: "Philippinen",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua-Neuguinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palästina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norwegen",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Neuseeland",
  新喀里多尼亚: "Neukaledonien",
  荷属安德列斯群岛: "Niederländische Antillen",
  荷兰: "Niederlande",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mosambik",
  摩洛哥: "Marokko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolei",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldau",
  墨西哥: "Mexiko",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauretanien",
  马里亚纳群岛: "Marianen",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Malediven",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Nordmazedonien",
  中国澳门: "Macau (China)",
  卢森堡: "Luxemburg",
  立陶宛: "Litauen",
  列支敦士登: "Liechtenstein",
  利比亚: "Libyen",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Lettland",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgisistan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenia",
  哈萨克斯坦: "Kasachstan",
  约旦: "Jordanien",
  日本: "Japan",
  牙买加: "Jamaika",
  象牙海岸: "Elfenbeinküste",
  意大利: "Italien",
  以色列: "Israel",
  爱尔兰: "Irland",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesien",
  印度: "Indien",
  冰岛: "Island",
  匈牙利: "Ungarn",
  中国香港: "Hongkong (China)",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grönland",
  希腊: "Griechenland",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Deutschland",
  格鲁吉亚: "Georgien",
  冈比亚: "Gambia",
  加蓬: "Gabun",
  法属波利尼西亚: "Französisch-Polynesien",
  法属圭亚那: "Französisch-Guayana",
  法国: "Frankreich",
  芬兰: "Finnland",
  斐济: "Fidschi",
  法罗群岛: "Färöer",
  埃塞俄比亚: "Äthiopien",
  爱沙尼亚: "Estland",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Äquatorialguinea",
  萨尔瓦多: "El Salvador",
  埃及: "Ägypten",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominikanische Republik",
  多米尼加: "Dominica",
  吉布提: "Dschibuti",
  丹麦: "Dänemark",
  捷克: "Tschechien",
  塞浦路斯: "Zypern",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Kroatien",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Elfenbeinküste",
  库克群岛: "Cookinseln",
  科摩罗: "Komoren",
  哥伦比亚: "Kolumbien",
  智利: "Chile",
  乍得: "Tschad",
  中非共和国: "Zentralafrikanische Republik",
  佛得角: "Kap Verde",
  开曼群岛: "Kaimaninseln",
  开普: "Kap",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodscha",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgarien",
  文莱: "Brunei",
  巴西: "Brasilien",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnien und Herzegowina",
  玻利维亚: "Bolivien",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgien",
  白俄罗斯: "Weißrussland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesch",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Aserbaidschan",
  奥地利: "Österreich",
  澳大利亚: "Australien",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenien",
  阿根廷: "Argentinien",
  安提瓜和巴布达: "Antigua und Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikanisch-Samoa",
  阿尔及利亚: "Algerien",
  中国: "China",

  日收益: "Täglicher Gewinn",
  "30天预期收益": "Erwarteter Gewinn für 30 Tage",
  英伟达高速矿机: "NVIDIA Hochgeschwindigkeits-Mining-Rig",
  去投资: "Zur Investition gehen",
  新币榜: "Liste neuer Münzen",
  主题: "Thema",
  立即探索: "Jetzt erkunden",
  等您来: "Wir erwarten Sie",
  最新活动: "Neueste Aktivitäten",
  货币划转: "Währungsübertragung",
  提现钱包: "Auszahlungsportemonnaie",
  加密合约: "Krypto-Kontrakt",
  外汇期货: "Devisen-Futures",
  定期: "Festgeld",
  探索产品: "Produkte erkunden",
  稳健型: "Konservativer Typ",
  高收益: "Hoher Ertrag",
  期货账户: "Futures-Konto",
  时间线: "Zeitleiste",
  收藏: "Favoriten",
  委托订单: "Auftrag zur Kommission",
  最新交易: "Neueste Transaktionen",
  深度图: "Tiefenbild",
  标记价格: "Marktpreis",
  "24h最高价": "Höchstpreis in 24h",
  "24h成交量": "Handelsvolumen in 24h",
  "24h最低价": "Tiefstpreis in 24h",
  "24h成交额": "Handelswert in 24h",
  "价格(USDT)": "Preis (USDT)",
  "数量(ETH)": "Menge (ETH)",
  看空: "Kurzposition",
  余额不足: "Unzureichender Saldo",
  最低购买: "Mindestkauf",
  最高购买: "Maximalkauf",
  下单成功: "Auftrag erfolgreich platziert",
  平仓成功: "Position erfolgreich geschlossen",
  请输入正确的平仓数量:
    "Bitte geben Sie die korrekte Menge zum Schließen der Position ein",
  加仓成功: "Position erfolgreich erhöht",
  请输入正确的加仓金额:
    "Bitte geben Sie den korrekten Betrag zur Erhöhung der Position ein",
  收藏成功: "Erfolgreich zu Favoriten hinzugefügt",
  取消收藏成功: "Erfolgreich aus Favoriten entfernt",
  日收益率: "Tägliche Ertragsrate",
  轻松理财: "Einfache Vermögensverwaltung",
  立即申购: "Jetzt subscribieren",
  申购日期: "Subskriptionsdatum",
  加密货币: "Kryptowährung",
  交割合约: "Lieferkontrakt",
  最小投资: "Mindestinvestition",
  委托: "Kommission",
  "当指数价格触达时，将会触发委托平仓":
    "Wenn der Indexpreis erreicht wird, wird eine kommissionierte Positionsschließung ausgelöst",
  预计盈利: "Erwarteter Gewinn",
  最大投资: "Maximalinvestition",
  现货交易: "Krypto-Handel",
  输入交易金额: "Geben Sie den Handelsbetrag ein",
  "可用额度：": "Verfügbares Limit:",
  提现货币: "Auszahlungswährung",
  期货合约: "Futures-Kontrakt",
  加密币永续: "Krypto-Perpetual",
  外汇永续: "Forex-Perpetual",
  期权账户: "Optionskonto",
  夜间模式: "Nachtmodus",
  未结盈亏: "Ohne Gewinn",
  超额收益: "Überschreitender Gewinn",
  "安全策略，低买高卖": "Sicherheitsstrategie, niedriger Kauf und Verkauf",
  投资金额应为: "Der Investitionsbetrag sollte",
  总收益率: "Gesamtrendite",
  赎回成功: "Erlösung erfolgreich",
  快捷卖币: "Schneller Verkauf",
  修改止盈止损: "Take-Profit/Stop-Loss ändern",
  白皮书: "Weißbuch",

  托管资金: "Verwaltete Gelder",
  托管中: "In Verwaltung",
  预计日收益: "Erwartete tägliche Rendite",
  累计收益: "Gesamtertrag",
  周期: "Zeitraum",
  日收益: "Tägliche Rendite",
  限额: "Limit",
  立即托管: "Jetzt verwalten",
  "已鎖定 請聯繫客服": "Gesperrt, bitte kontaktieren Sie den Kundenservice",
  产品列表: "Produktliste",
  规则: "Regeln",
  创建订单: "Bestellung erstellen",
  产品名称: "Produktname",
  托管周期: "Verwaltungszeitraum",
  等级限制: "Level-Beschränkung",
  托管金额: "Verwaltungsbetrag",
  限额: "Limit",
  余额: "Guthaben",
  购买日: "Kaufdatum",
  起息日: "Zinsbeginn",
  派息时间: "Auszahlungszeit",
  每天: "Täglich",
  计息结束日: "Zinsende",
  每日收益: "Tägliche Erträge",
  预计收益: "Erwartete Erträge",
  "收益将自动发送至您的余额账户;":
    "Die Erträge werden automatisch auf Ihr Guthabenkonto überwiesen;",
  "您的资金没有任何风险;": "Ihr Kapital ist keinem Risiko ausgesetzt;",
  "365*24小时不断地工作;": "365 Tage im Jahr, 24 Stunden ununterbrochen aktiv;",
  托管中: "In Verwaltung",
  结束: "Beendet",
  今日收益: "Heutiger Ertrag",
  剩余周期: "Verbleibender Zeitraum",
  进行中: "Laufend",
  已发放: "Ausgezahlt",
  信誉分: "Reputationspunkte",

  复制成功: "Erfolgreich kopiert",
  VIP权益: "VIP-Vorteile",
  旧密码: "Altes Passwort",
  请输入旧密码: "Altes Passwort eingeben",
  "忘记旧密码请联系客服重置。":
    "Wenn Sie Ihr altes Passwort vergessen haben, kontaktieren Sie bitte den Kundenservice, um es zurückzusetzen.",
  去升级: "Jetzt upgraden",
  描述: "Beschreibung",
  实际存款金额: "Tatsächlicher Einzahlungsbetrag",
  升级礼金: "Upgrade-Bonus",
  隔夜利息: "Übernachtzinsen (Swap)",
  自动结算: "Automatische Abrechnung",
  等级规则: "Stufenregeln",
  "WEB3.0币持有数据收益": "Datenrendite aus WEB3.0-Token-Beständen",
  总生产: "Gesamtproduktion",
  有效节点: "Aktive Knoten",
  参与人: "Teilnehmer",
  用户收益: "Benutzerertrag",
  "流动性WEB3.0输出": "Liquiditäts-WEB3.0-Output",
  总资产: "Gesamtvermögen",

  ETHAI持有数据收益: "ETHAI Bestandsdatenertrag",
  AI量化流动性: "KI-quantitative Liquidität",
  现货买入手续费: "Spot-Kaufgebühr",
  现货支出: "Spot-Ausgabe",
  现货资金费率: "Spot-Finanzierungsrate",
  现货卖出手续费: "Spot-Verkaufsgebühr",
  现货收入: "Spot-Einnahme",
  外汇合约支出: "Devisenterminkontrakt-Ausgabe",
  外汇合约买入手续费: "Devisenterminkontrakt-Kaufgebühr",
  外汇合约资金费率: "Devisenterminkontrakt-Finanzierungsrate",
  外汇合约卖出手续费: "Devisenterminkontrakt-Verkaufsgebühr",
  外汇合约收入: "Devisenterminkontrakt-Einnahme",
  理财购买: "Finanzprodukt-Kauf",
  VIP理财日收益: "VIP-Finanzprodukt-Tagesertrag",
  VIP理财隔夜利息: "VIP-Finanzprodukt-Übernachtzins",
  VIP本金返还: "VIP-Rückzahlung der Einlage",
  VIP彩金发放: "VIP-Bonusausschüttung",
  VIP彩金抵扣: "VIP-Bonusverrechnung",
  隔夜利息: "Übernachtzins",
  设置资产密码: "Vermögens-Passwort einrichten",

  锁仓挖矿: "Locked Mining",
  一站式理财服务: "Finanzdienstleistungen aus einer Hand",
  产品: "Produkte",
  客服中心: "Kundencenter",
  贷款: "Darlehen",
  挖矿赚不停: "Ununterbrochen Mining-Erträge erzielen",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Locked Mining erfolgt durch die Verwahrung von USDT (USD:1USDT=1USD) in den Hochleistungs-Mining-Geräten der Plattform, um Mining-Erträge im Mining-Pool der Plattform zu erzielen.",
  产品优势: "Produktvorteile",
  随存随取: "Jederzeit einzahlen und abheben",
  锁仓周期: "Sperrfrist",
  每日下发: "Tägliche Ausschüttung",
  随机空投: "Zufälliger Airdrop",
  "100%资金安全保障": "100% Sicherheit der Gelder",
  "100%节假日收益不间断": "100% kontinuierliche Erträge auch an Feiertagen",
  成功锁仓后当天产出: "Erträge noch am Tag der erfolgreichen Sperrung",
  关于违约金: "Über Vertragsstrafen",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Wenn Sie das Kapital vor Ablauf auszahlen möchten, fällt eine Vertragsstrafe an. Vertragsstrafe = Strafsatz × verbleibende Tage × gesperrter Betrag.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Beispiel: Der Strafsatz dieses Locked Mining beträgt 5 %, es verbleiben 3 Tage bis zur Fälligkeit und der Sperrbetrag beträgt 10000U (USDT/USD). Die Vertragsstrafe beträgt somit 5%*3*10000=1500U, der tatsächlich zurückgezahlte Betrag ist 15000U-1500U.",
  收益计算: "Ertragsberechnung",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Die Plattform bietet verschiedene Locked-Mining-Finanzprodukte zur Auswahl an. Die Ertragsberechnung erfolgt wie folgt, zum Beispiel:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Wenn ein Mitglied 10000U (USDT, USD) auf der Plattform sperrt und ein 7-Tage-Produkt mit einem täglichen Ertrag von 0,7%~1,8% des Sperrbetrags wählt, ergibt sich folgender täglicher Ertrag:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Nach 7 Tagen können somit Erträge von 490U~1260U erzielt werden. Die Erträge werden täglich ausgeschüttet, und nach Ablauf wird das gesperrte Kapital automatisch auf Ihr Finanzkonto übertragen.",
  正在托管的资金: "Verwaltete Gelder",
  签到: "Einchecken",
  锁仓订单: "Locked-Mining-Aufträge",
  预计今日收益: "Voraussichtlicher Tagesertrag",
  累计收益: "Kumulierte Erträge",
  托管中的订单: "Aufträge in Verwahrung",
  单笔最少: "Mindestbetrag pro Auftrag",
  单笔最多: "Höchstbetrag pro Auftrag",
  日收益率: "Tägliche Rendite",
  说明: "Hinweis",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Die Datenerfassung erfolgt nach GMT+8<br>2. Die täglichen Erträge werden auf Basis aller abgeschlossenen Aufträge zwischen 00:00–23:59 Uhr GMT+8 (Ortszeit 00:00–23:59) berechnet<br>3. Die Erträge des Tages werden gesammelt zwischen 00:00–00:10 Uhr GMT+8 des Folgetages ausgeschüttet.",
  知道了: "Verstanden",
  锁仓: "Sperren",
  派息时间: "Zeit der Ausschüttung",
  每日: "Täglich",
  托管资金: "Verwahrte Gelder",
  到期返回: "Rückgabe bei Fälligkeit",
  提前赎回: "Vorzeitige Rückzahlung",
  预计收益: "Voraussichtlicher Ertrag",
  认购: "Zeichnen",
  热门: "Beliebt",
  数字货币: "Digitale Währungen",
  贵金属: "Edelmetalle",
  大宗商品: "Rohstoffe",
  持仓明细: "Positionsdetails",
  历史明细: "Historie",
  当前价: "Aktueller Preis",
  "↑买涨": "↑ Auf steigende Kurse setzen",
  "↓买跌": "↓ Auf fallende Kurse setzen",
  显示全部: "Alle anzeigen",
  买入金额: "Kaufbetrag",
  方向: "Richtung",
  收益: "Ertrag",
  预期收益: "Erwarteter Ertrag",
  估用保证金: "Geschätzte Margin",
  确认下单: "Bestellung bestätigen",
  锁定: "Gesperrt",
  账户总资产: "Gesamtvermögen des Kontos",
  明细: "Details",
  今日收益: "Heutiger Ertrag",
  仓位保证金: "Positionsmargin",
  持有仓位: "Gehaltene Positionen",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Gesperrter Betrag = Summe aller nicht abgeschlossenen Locked-Mining-Aufträge",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Die Datenerfassung erfolgt nach GMT+8<br>2. Die täglichen Erträge werden auf Basis aller abgeschlossenen Aufträge zwischen 00:00–23:59 Uhr GMT+8 (Ortszeit 00:00–23:59) berechnet",
  充值方式: "Einzahlungsmethode",
  银行汇款: "Banküberweisung",
  "银行汇款请联系客服进行操作!":
    "Bitte kontaktieren Sie den Kundendienst für Banküberweisungen!",
  提款方式: "Auszahlungsmethode",
  "银行提款请联系客服进行操作!":
    "Bitte kontaktieren Sie den Kundendienst für Bankauszahlungen!",
  资金明细: "Finanzdetails",
  提现记录: "Auszahlungsverlauf",
  拒绝: "Abgelehnt",
  通过: "Genehmigt",
  拒绝原因: "Ablehnungsgrund",

  消息公告: "Mitteilungen",
  订单: "Bestellungen",
  个人中心: "Persönliches Zentrum",
  "未到期赎回需支付一定的违约金!":
    "Bei vorzeitiger Rückzahlung ist eine Vertragsstrafe zu zahlen.",

  请输入区号: "Bitte geben Sie die Vorwahl ein",
  "请选择国家/地区": "Bitte wählen Sie ein Land/eine Region aus",

  今日开盘: "Heutige Eröffnung",
  昨日收盘: "Gestern Schlusskurs",

  实名认证即送: "Sofort nach der Identitätsprüfung erhalten",
  立即认证: "Jetzt verifizieren",
  新用户礼包: "Neues Benutzer-Willkommenspaket",
  完成新人任务领取:
    "Schließe die Aufgaben für neue Benutzer ab, um es zu erhalten",
  认证: "Verifizieren",
  时间周期: "Zeitraum",
  支付金额: "Zahlungsbetrag",
  已平仓: "Geschlossen",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX-Willkommenspaket für neue Benutzer: Jeder Benutzer kann maximal erhalten",
  我已经阅读并同意: "Ich habe gelesen und stimme zu",
  隐私政策: "Datenschutzerklärung",
  放弃奖励离开: "Belohnung aufgeben und verlassen",
  继续注册: "Registrierung fortsetzen",
  分钟: "Minuten",

  "请先勾选隐私政策!": "Bitte lesen Sie zuerst die Datenschutzerklärung!",
  添加其他到自选: "Weitere zur Beobachtungsliste hinzufügen",
  充值最高可得: "Laden Sie Ihr Guthaben auf und erhalten Sie bis zu 30.000 $.",

  请输入格式正确的手机号: "Bitte geben Sie eine gültige Mobilfunknummer ein.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 德语



// WEBPACK FOOTER //
// ./src/lang/de.js